import { useEffect, useState } from 'react';

const prefersReduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const useStepper = (count, resetKey, { delay = 1300, autoplay = true } = {}) => {
  const [i, setI] = useState(count - 1);
  const [playing, setPlaying] = useState(false);
  const [nonce, setNonce] = useState(0);
  const start = () => { if (prefersReduced()) { setPlaying(false); setI(count - 1); return; } setI(0); setPlaying(true); setNonce((v) => v + 1); };

  useEffect(() => { if (resetKey !== undefined && autoplay) start(); }, [resetKey]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!playing) return;
    if (i >= count - 1) { setPlaying(false); return; }
    const t = setTimeout(() => setI((v) => v + 1), delay);
    return () => clearTimeout(t);
  }, [playing, i, nonce, count, delay]);

  const toggle = () => {
    if (playing) { setPlaying(false); return; }
    if (i >= count - 1) { start(); return; }
    setPlaying(true); setNonce((v) => v + 1);
  };
  const go = (k) => { setPlaying(false); setI(Math.max(0, Math.min(count - 1, k))); };
  return { i, playing, toggle, replay: start, go };
};
